// utils/tagColors.ts — colores para los chips del catálogo (rubros, categorías).
// Round 2026-06-30. Al crear una etiqueta se le asigna un color AL AZAR de la
// paleta; si una etiqueta vieja no tiene color guardado, se usa un color
// DETERMINÍSTICO derivado de su nombre (estable entre renders) para que igual se
// vea con color en las tablas.

/** Paleta de colores agradables y bien contrastados para los chips. */
export const TAG_PALETTE = [
  "#7C3AED", // violeta (marca)
  "#2563EB", // azul
  "#0891B2", // cian
  "#059669", // verde
  "#65A30D", // lima
  "#CA8A04", // ámbar
  "#EA580C", // naranja
  "#DC2626", // rojo
  "#DB2777", // rosa
  "#9333EA", // púrpura
  "#4F46E5", // índigo
  "#0D9488", // teal
  "#B45309", // marrón
  "#475569", // gris pizarra
];

/** Color aleatorio de la paleta (para asignar al crear una etiqueta). */
export function randomTagColor(): string {
  return TAG_PALETTE[Math.floor(Math.random() * TAG_PALETTE.length)];
}

/** Color determinístico a partir del nombre (fallback estable si no hay color). */
export function colorFromName(name: string): string {
  let h = 0;
  const s = name || "";
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TAG_PALETTE[h % TAG_PALETTE.length];
}

/** Color efectivo de una etiqueta: el guardado, o el derivado del nombre. */
export function tagColor(name: string, stored?: string | null): string {
  return stored || colorFromName(name);
}
